import { map, assoc } from 'ramda';
import * as types from '../constants';
import {
  CLEAR_ITEMS,
  FETCH_ITEMS,
} from '../../../products/brands/constants';

const transform = item => ({
  id: item.id,
  title: item.name,
  checked: true,
  type: 'brand',
});
const transformToFilter = map(transform);

const brandFilters = (state = [], action) => {
  switch (action.type) {
    case CLEAR_ITEMS:
      return [];
    case FETCH_ITEMS:
      return [
        transform({
          id: 'unbranded',
          name: 'Unbranded',
        }),
        ...transformToFilter(action.payload),
      ];
    case types.UPDATE_BRAND_FILTER:
      return state.map((filter) => {
        if (filter === action.payload) {
          filter.checked = !filter.checked;
        }
        return filter;
      });
    case types.UPDATE_BRAND_FILTER_SELECT_ALL:
    case types.RESET_FILTERS:
      return map(filter => assoc('checked', true, filter), state);
    case types.UPDATE_BRAND_FILTER_DESELECT_ALL:
      return map(filter => assoc('checked', false, filter), state);
    default:
  }
  return state;
};

export default brandFilters;
